export default {
   
    carpeta: {
    }
}